var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c(
    "w-row",
    { attrs: { grow: "" } },
    [
      !_vm.ready
        ? _c(
            "w-col",
            { attrs: { xs: "12", center: "" } },
            [
              _c("p", { staticClass: "title" }, [
                _vm._v(" " + _vm._s(_vm.$ct("mollie-authenticating")) + " "),
              ]),
              _c("w-progress-circular", { attrs: { large: "" } }),
            ],
            1
          )
        : _c(
            "w-col",
            { attrs: { xs: "12", grow: "" } },
            [
              _c(
                "w-card",
                [
                  _c("w-card-title", [
                    _vm._v(_vm._s(_vm.$ct("mollie-profile-select"))),
                  ]),
                  _c(
                    "w-scroll-view",
                    { attrs: { tag: "w-list" } },
                    [
                      _vm._l(_vm.profiles, function (profile) {
                        return _c(
                          "w-list-item",
                          {
                            key: profile.ID,
                            on: {
                              click: function ($event) {
                                return _vm.setProfile(profile)
                              },
                            },
                          },
                          [
                            _c("w-list-item-text", [
                              _vm._v(_vm._s(profile.Name)),
                            ]),
                          ],
                          1
                        )
                      }),
                      _c(
                        "w-list-item",
                        {
                          on: {
                            click: function ($event) {
                              _vm.newProfileModal = true
                            },
                          },
                        },
                        [
                          _c("w-list-item-text", [
                            _c(
                              "div",
                              [
                                _c("w-fa", { attrs: { icon: "plus" } }),
                                _vm._v(
                                  " " +
                                    _vm._s(_vm.$ct("create-mollie-profile")) +
                                    " "
                                ),
                              ],
                              1
                            ),
                          ]),
                        ],
                        1
                      ),
                    ],
                    2
                  ),
                ],
                1
              ),
            ],
            1
          ),
      _c(
        "w-modal",
        {
          model: {
            value: _vm.newProfileModal,
            callback: function ($$v) {
              _vm.newProfileModal = $$v
            },
            expression: "newProfileModal",
          },
        },
        [
          _vm.newProfileModal
            ? _c("app-create-mollie-profile", {
                on: {
                  cancel: function ($event) {
                    _vm.newProfileModal = false
                  },
                  input: function ($event) {
                    return _vm.setProfile($event)
                  },
                },
              })
            : _vm._e(),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }